export enum SourceSchemaFieldType {
  NOT_SET = 'SSFT_NOT_SET',
  STRING = 'SSFT_STRING',
  INTEGER = 'SSFT_INTEGER',
  DECIMAL = 'SSFT_DECIMAL',
  BOOLEAN = 'SSFT_BOOLEAN'
}

export enum DestinationSchemaFieldType {
  NOT_SET = 'DSFT_NOT_SET',
  STRING = 'DSFT_STRING',
  INTEGER = 'DSFT_INTEGER',
  DECIMAL = 'DSFT_DECIMAL',
  BOOLEAN = 'DSFT_BOOLEAN'
}

export interface SchemaFieldObjectType {
  fields: SchemaField[];
}

export interface SchemaFieldArrayType {
  primitive_type?: SourceSchemaFieldType | DestinationSchemaFieldType;
  object_schema?: SchemaFieldObjectType;
}

export interface SchemaField {
  id: string;
  display_name: string;
  description: string;
  required: boolean;
  primitive_type?: SourceSchemaFieldType | DestinationSchemaFieldType;
  object_schema?: SchemaFieldObjectType;
  array?: SchemaFieldArrayType;
}

export interface Schema {
  id: string;
  display_name: string;
  fields: SchemaField[];
}

export interface CGDestinationSchema extends Schema {
  cg_metadata?: CGSchemaMetadata;
}

export interface CGSchemaMetadata {
  source_product: string;
  source_object_name: string;
  created_by: string;
}

export interface DestinationSchemaItem {
  id: string;
  display_name: string;
}

export interface GetSchemaResponse {
  schema: Schema;
}

export interface GetCGDestinationSchemaResponse {
  schema: CGDestinationSchema;
}

export interface ListDestinationSchemasResponse {
  schemas: DestinationSchemaItem[];
}
